  <div *ngIf="isMediaModalShown"
    id="media_popup" class="modal fade media-modal-container" 
    tabindex="-1" role="dialog" 
    [config]="{ show: true, backdrop: 'relative' }" 
    (onHidden)="onHidden()" 
    bsModal 
    #autoShownModal="bs-modal">
    <div class="custom-theme-modal modal-dialog modal-md modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-body p-0" *ngIf="mediaObj?.length>0">
            <span class="gallery-close-icon" 
              (click)="hideModal()">
              <span class="position-fixed">
                <img src="assets/themes/icons/gallery-close-icon.svg" alt="close icon" />
              </span>
            </span>
          <div class="custom-mdb-carousel">
            <mdb-carousel id="mdbcr" 
              [type]="'carousel-fade'" 
              tabindex="1" 
              [activeSlideIndex]="openMediaIndex" 
              [(activeSlide)]="last_index" 
              class="carousel slide carousel-fade media-slider" 
              [animation]="'fade'"  
              [isControls]="true" 
              [interval]="0"  
              [keyboard]="true" 
              (activeSlideChange)="log($event)">
                {{setslidercls()}}
              <mdb-carousel-item *ngFor="let Ml of mediaObj;let i = index">
                <div *ngIf="Ml['media_type']=='video' && i === last_index.relatedTarget">
                  <app-shaka-basic 
                    [videoSrc]="Ml['media_url']" 
                    [videoBanner]="Ml['media_thumbnail']" 
                    shakaStyleCss='shaka-model'>
                  </app-shaka-basic>
                </div>
                <div *ngIf="Ml['media_type']=='youtube'">
                  <video class="modal_shadow video-content" controls  
                    name="media">
                    <source [src]="Ml['media_url']" >
                  </video>
                </div>
                <div *ngIf="Ml['media_type']=='audio'">
                  <audio controls autoplay controlsList="nodownload" controlslist="novolume">
                      <source  [src]="Ml['media_url']" type='audio/mp3'>
                  </audio>
                </div>
                <div class="w-100">
                  <img *ngIf="Ml['media_type']=='image'" 
                    class="d-block w-100 img-content" 
                    [src]="Ml['media_url'] | fitInImg :igs.imageGroup.fitin_500x500"  
                    onerror="this.src='assets/themes/images/banner-placeholder-lg.svg';" 
                     zoom>
                </div>
                <div class="pdf-view" 
                  *ngIf="Ml['media_type']=='document' || Ml['media_type']=='documentPost' || Ml['media_type']=='documentEdit' ">
                  <app-pdf-view  
                    [pdfscr]="pdfSrc1" 
                    [show_all_page]="true">
                  </app-pdf-view>
                </div>
              </mdb-carousel-item>
            </mdb-carousel>
          </div>
        </div>
      </div>
    </div>
  </div>